import React, { Component, Fragment } from 'react';
import API from '../../shared/forms/API';
import moment from 'moment';
import { employeeDateTimeFormat } from '../EmployeesState';
import TableBody from '../../shared/tables/TableBody';
import environment from "../../shared/Environment";
import NotificationPreviewModal from '../../notifications/NotificationPreviewModal';

const types = {
  sms: 'SMS',
  mail: 'E-mail'
};

export default class EmployeesNotificationsView extends Component {
  uuid = null;
  state = {
    notifications: null,
    previewUuid: null
  };

  componentDidMount() {
    this.componentDidUpdate();
  }

  componentDidUpdate() {
    if (this.props.employee.uuid === this.uuid) {
      return;
    }

    this.uuid = this.props.employee.uuid;
    this.setState({ notifications: null });

    new API()
      .fetch('notifications?receiver_employee=' + this.props.employee.uuid, 'GET')
      .then((response) => response.json())
      .then((response) => this.setState({ notifications: response.results }));
  }

  render() {
    const { previewUuid } = this.state;
    return (
      <Fragment>
        <div className="card">
          {' '}
          <table className="table table-hover mb-0">
            <thead>
              <tr>
                <th className="no-border">&nbsp;</th>
                <th className="no-border">Bericht</th>
                <th className="no-border">Via</th>
              </tr>
            </thead>
            <TableBody colSpan="3" placeholder="Geen notificaties">
              {this.state.notifications && this.state.notifications.map(this.renderNotification)}
            </TableBody>
          </table>
        </div>
        {previewUuid && (
          <NotificationPreviewModal
            key={previewUuid}
            uuid={previewUuid}
            open={true}
            onClose={() => this.setState({ previewUuid: null })}
          />
        )}
      </Fragment>
    );
  }
  renderNotification = (notification, index) => {
    const dateSent = moment(notification.send_on, employeeDateTimeFormat);
    const dateScheduled = moment(notification.send_after, employeeDateTimeFormat);

    let icon = null;
    let dateText = null;

    if (dateSent.isValid()) {
      icon =  <i className="fa fa-calendar-check-o" />;
      dateText = dateSent.format('LLL');
    } else if (dateScheduled.isValid()) {
      icon = <i className="fa fa-calendar" />;
      dateText = 'Gepland ' + dateScheduled.fromNow();
    } else {
      dateText = 'Wachtrij';
    }

    return (
      <tr
        key={index}
        onClick={() => this.setState({ previewUuid: notification.uuid })}
        style={{ cursor: 'pointer' }}
      >
        <td>{icon}</td>
        <td>
          <div>{environment.NOTIFICATION_LABELS[notification.event] || notification.event}</div>
          <div className="text-muted small">{dateText}</div>
        </td>
        <td>{types[notification.type]}</td>
      </tr>
    );
  };
}
